import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { ProductService } from '@app/shared/services/product/product.service';
import { OrderService } from './order.service';
import { Store } from '@ngrx/store';
import { MyOrdersStoreService } from '@usf/ngrx-order';
import { Observable } from 'rxjs';
import { MerchandisingService } from '@shared/services/merchandising/merchandising.service';
import { CustomerStoreService } from '@app/ngrx-customer/services';
import { LoadingSpinnerService } from '@shared/services/loading-spinner/loading-spinner.service';
import { BaseOrderResolver } from './base-order-resolver';

@Injectable({
  providedIn: 'root',
})
export class OrderPageResolverResolver extends BaseOrderResolver {
  constructor(
    store: Store,
    productService: ProductService,
    orderService: OrderService,
    merchandisingService: MerchandisingService,
    spinner: LoadingSpinnerService,
    customerStoreService: CustomerStoreService,
    myOrdersStoreService: MyOrdersStoreService,
  ) {
    super(
      store,
      productService,
      orderService,
      merchandisingService,
      spinner,
      customerStoreService,
      null, // homeService is not needed for this resolver
      myOrdersStoreService,
      null, // router is not needed for this resolver
    );
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<number[]> {
    this.spinnerPromise = this.spinner.createSpinnerModal(true);
    this.initializeReadyForProductSelection();
    this.fetchAndLoadFrequentlyBoughtTogether();
    return this.loadProducts();
  }
}
